// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider_sliderWrapper__alJUk","sliderValues":"Slider_sliderValues__SSb4P","disabled":"Slider_disabled__3s8rS"};